import cache from './cache.js';
import isMacOs from './isMacOs.js';

// This is tricky because UA and navigator.platform 
// report as a MacIntel desktop in iPadOS.
// 
// NOTE: come up with a more reliable iPadOS detection, as this will 
// likely fail when MacOS gets touch screens and other mobile-like 
// capability.
export default cache('isIpad', function isIpad() {
  return isMacOs() && !!navigator.maxTouchPoints && navigator.maxTouchPoints === 5;
});